import { cn } from '#src/styling/cn.ts';
import type { ComponentProps } from 'react';

export type AnchorProps = ComponentProps<'a'>;

export const Anchor = ({ children, className, ...props }: AnchorProps) => {
  return (
    <a
      className={cn('inline-flex items-center underline-offset-2 hover:underline', className)}
      {...props}
    >
      {children}
    </a>
  );
};
